import { _sharedReducerLibrary, _sharedStateLibrary } from "@/shared/store/library/reducer";

export const initialState = {
  ..._sharedStateLibrary,
  a: "fd"
};

const libraryReducer = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    default:
      return _sharedReducerLibrary(state, action);
  }
};

export default libraryReducer;
